import {useRef, useEffect, useContext} from 'react';
import { PopUpContextType, PopUpStates } from '../Interfaces';

export default function Popup({onClose, message, title} : PopUpContextType){
 
    const boxRef = useRef<HTMLDivElement | null>(null);


    useEffect(() => {

        const handleClick = (e : MouseEvent) => {
            if (boxRef.current && boxRef.current.contains(e.target as Node)){
             
            }else{
                onClose();
            }
        }   

        document.addEventListener("mousedown", handleClick);


        return () => {
            document.removeEventListener("mousedown", handleClick);
        }
    },[])

    return (
        <>
        <div className={"popup-background"}>
            <div ref={boxRef} className={"popup"}>
                <h2>{title}</h2>
                <p>{message}</p>
                <button className='popup-btn'>Ok</button>
            </div>        
        </div>
        
        </>
    )
}